// app/routes/index.tsx
import { createFileRoute } from "@tanstack/react-router";
import { Separator } from "@/components/ui/separator";
import { Activities } from "@/components/www/sections/activities";
import { GroupBooking } from "@/components/www/sections/group-booking";
import { Hero } from "@/components/www/sections/hero";
import { History } from "@/components/www/sections/history";
import { News } from "@/components/www/sections/news";
import { seo } from "@/lib/seo";

export const Route = createFileRoute("/_www/")({
  component: Home,
  head: () =>
    seo({
      title: "Alte Papierfabrik Wuppertal – Bowling & 3D Schwarzlicht Minigolf",
      description:
        "Bowling und 3D-Schwarzlicht Minigolf in Wuppertal. 12 Hightech-Bahnen, riesige LED-Wand und Indoor-Minigolf – jetzt online buchen!",
      path: "/",
      imageAlt:
        "Bowlingbahn und 3D-Schwarzlicht Minigolf in der Alten Papierfabrik Wuppertal",
    }),
});

function Home() {
  return (
    <>
      <Hero />
      <GroupBooking />
      <News />
      <Separator className="!h-0.5 !w-4/5 mx-auto bg-foreground" />
      <Activities />
      <History />
    </>
  );
}
